import messages from './myCases.json' with { type: 'json' };

export const myCasesSv: Readonly<typeof messages> = messages;
